import Vue from 'vue';
import Component from 'vue-class-component';
import Moment from 'moment';
import { Watch } from 'vue-property-decorator';
import EdSubjectCalendar from '@/courses/components/ed-subject-builder-v2/ed-subject-calendar/ed-subject-calendar.component.vue';
import EdCreateProductComponent from '@/courses/components/ed-create-product-v2/ed-create-product.component.vue';
import { ALL_CONTENT_ROUTES } from '@/app/private/my-content/views/all/all.router';
import { TOAST_TYPES } from '@/plugins/ed-toast/values/ed-toast.values';
import { BUILDER_CALENDAR_TYPES, BUILDER_MENU_V2, BUILDER_EVENT_TYPES as FIXED, BUILDER_RULES, BUILDER_DAY_OPTIONS, DAYS_OF_WEEK, BUILDER_STATUS, BUILDER_SYNC_STATUS, BUILDER_SCHOOL_DAY_TYPES } from '@/courses/values/courses.values';
import { COURSE_TEMPLATE_EVENTS, PRODUCT_TYPES } from '@/course-templates/values/course-templates.values';
import { COURSES_EVENTS } from '@/courses/values/courses-events.values';
import { EdTabsHeaderOption } from '@/models/ed-tabs-header-option.model';
import { Status } from '@/models/status.model';
import KEYS from '@/values/keys';
import { IParamsCreateComponent } from '@/courses/interfaces/params-create-component.interface';
import { CONTENT_TYPE } from '@/classes/values/classes.values';
import { FILESCACHE_KEYS } from '@/shared/plugins/files-cache/enums/files-cache.enum';
import { BuilderData, BuilderLesson, BuilderRule, Structure } from '../../models/builder.model';
import { ContentSchedule } from '@/tools/models/class-builder.models';
import Course from '@/content/models/course.model';
import _ from 'lodash';
import log from 'js-logger';
// import ServerStatusWorker from 'worker-loader!@/workers/server-status-worker.ts';
// import { APP_API } from '@/core/values/app.values';

import EdStepper from '@/components/common/ed-stepper/ed-stepper.vue';
import { WORKING_DAYS } from '@/tools/values/schedule.values';
import { WORKER_EVENT_BUS } from '@/core/enums/worker.enum';
import { ClassesService } from '@/classes/services/classes.service';
import { OFFLINE_MODE_EVENT } from '@/core/values/core.values';
import { ScheduleTypeEnum } from '@/tools/enums/schedule-type.enum';
import DeveloperBar from './developer-bar/developer-bar.vue';
import { BuilderService } from '@/courses/services/builder.service';

@Component({
  name: 'subject-builder',
  components: {
    EdSubjectCalendar,
    EdCreateProductComponent,
    EdSubjectBuildingProcess: () => import(/* EdSubjectBuildingProcess */'@/courses/components/ed-subject-builder-v2/ed-subject-building-process/ed-subject-building-process.component.vue'),
    EdSubjectBuilderSidebar: () => import(/* EdSubjectBuilderSidebar */'@/app/private/subjects/components/ed-subject-builder-sidebar/ed-subject-builder-sidebar.component.vue'),
    EdSubjectBuilderRules: () => import(/* EdSubjectBuilderRules */'@/courses/components/ed-subject-builder-v2/ed-subject-builder-rules/ed-subject-builder-rules.component.vue'),
    EdSubjectBuilderRulesList: () => import(/* EdSubjectBuilderRulesList */'@/courses/components/ed-subject-builder-v2/ed-subject-builder-rules-list/ed-subject-builder-rules-list.component.vue'),
    EdSubjectBuilderContentSidebar: () => import(/* EdSubjectBuilderContentSidebar */'@/courses/components/ed-subject-builder-v2/ed-subject-builder-content-sidebar/ed-subject-builder-content-sidebar.component.vue'),
    EdSubjectBuilderContent: () => import(/* EdSubjectBuilderContent */'@/courses/components/ed-subject-builder-v2/ed-subject-builder-content/ed-subject-builder-content.component.vue'),
    EdSubjectBuilderEditor: () => import(/* SubjectBuilderEditor */'@/courses/components/ed-subject-builder-v2/ed-subject-builder-editor/ed-subject-builder-editor.component.vue'),
    DeveloperBar,
    EdStepper,
  },
})
export default class SubjectBuilderView extends Vue {

  public status: Status = new Status();
  public showSpinner: boolean = true;
  public step: number = 1;
  public calendarTypes: any = BUILDER_CALENDAR_TYPES;
  public productType: any = PRODUCT_TYPES.BUILDER;
  public contentDetail: any = {};
  public disabledSubjectForm = false
  public menu: EdTabsHeaderOption[];
  public isTabMenuDisabled = false;
  public isButtonHidden = false;
  public buildingLog: string = '';
  public contentId: number = 0;
  public calendarType: string = '';
  public isEditionMode: boolean = false;
  public isSidebarOpened: boolean = false;
  public isSidebarContentOpened: boolean = false;
  public builder: BuilderData = {};
  public callBackup: any = {
    funDayoffBackup: false,
    prevFunDayOffDate: '',
    teachingDaysBackup: false,
    prevTeachingDays: [],
    prevResourceId: ''
  }
  public addRule: boolean = false;
  public ruleOptions: any = null;
  public templateIdFromQuickSubject = null;
  public initialType = null;
  public idBuilder: number = 0;
  private allCalendars: any[];
  private selectedSubjectDays : number;
  /* Server monitor worker */
  // private worker: any;
  public connected: boolean = true;

  public typeSchoolDay: string = '';
  public canAddTemplates: boolean = false;
  public disableSync: boolean = false;
  public isDeveloperMode: boolean = false;
  public disableSyncButtons: boolean = false;
  /* Computed */
  get isCalendarStep() {
    return this.calendarType == this.calendarTypes.CALENDAR;
  }

  get isLessonStep() {
    return this.step === 2;
  }

  get isCreateDetailStep() {
    return this.step === 1;
  }

  get quickContentId(): number {
    return this.isQuickSubject ? Number(this.$route.params.id) : null;
  }

  get templateId(): number {
    if(this.builder && this.builder.templateId )
      return this.builder.templateId;

    if (this.isQuickSubject)
      return this.templateIdFromQuickSubject;

    return  Number(this.$route.params.id);
  }

  get type(): string {
    return this.$route?.query?.type as string || CONTENT_TYPE.TEMPLATE;
  }

  get classId(): number {
    return Number(this.$route?.query?.classId)
  }

  get builderId(): number {
    this.idBuilder = this.$route?.query?.builderId ? Number(this.$route?.query?.builderId) : this.idBuilder;
    return this.idBuilder;
  }

  get syncStatus(): string {
    return this.$route?.query?.syncStatus as string  ?? '';
  }

  get isQuickSubject(): boolean {
    return this.type === CONTENT_TYPE.QUICK_SUBJECT || this.initialType === CONTENT_TYPE.QUICK_SUBJECT;
  }

  get disableEditWorkingDays() : boolean {
    return this.isQuickSubject || this.contentDetail?.status === BUILDER_STATUS.DONE;
  }

  get organizationId() {
    let institutions: any[] = this.$store.state.ToolsStore.institutionInfo;
    return institutions.length > 0 ? institutions[0].organizationId : null;
  }

  get startDateCalendar(): string {
    let date = this.schoolDay.startDate;

    return date?.substring(0, date.length - 2)+'01';
  }

  get endDateCalendar(): string {
    let date = this.schoolDay.endDate;
    let endOfMonth = Moment(date).clone().endOf('month').format('DD').toString();

    return date?.substring(0, date.length - 2)+endOfMonth;
  }

  get lessons(): any[] {
    return Array.from(this.builder?.allLessonsMap.values()) || [];
  }

  get specialDays(): any[] {
    return this.builder?.specialDays || [];
  }

  get workingDays(): any[] {
    return this.builder?.workingDays || [];
  }

  get additionalLessons(): any[] {
    return this.builder?.additionalLessons || [];
  }

  get schoolDay() {
    return this.builder?.schoolDay || {};
  }

  get existFunLessons(): number {
    return this.builder?.existFunLessons || 0;
  }

  get subject(): number {
    return this.builder?.subject || {};
  }

  get coverImage(): string {
    return this.builder?.coverImage || '';
  }

  get rulesApplied(): BuilderRule[] {
    return this.builder?.rulesApplied || [];
  }

  /*get rulesAppliedList(): any {
    return this.rulesApplied.filter(el => el.type === BUILDER_RULES.PLACE_LABELS_ON_WORKING_DAY || el.type === BUILDER_RULES.START_LESSON);
  }*/
  
  get objectsTagged(): any {
    return this.builder?.objectsTagged || [];
  }

  get automaticFolderType(): string {
    return this.builder?.automaticFolderType || null;
  }

  get componentsSelected(): IParamsCreateComponent[] {
    return this.builder?.componentsSelected || [];
  }

  get displayTypes() {
    const funLabel = this.isLessonStep ? 'funLesson' : 'fun';

    const types = [{
      label: this.$t('courses.subjectBuilder.contentLesson'),
      value: FIXED.CONTENT,
      className: 'legend-lesson-content',
    },{
      label: this.$t('courses.subjectBuilder.fillerLesson'),
      value: FIXED.FILLER,
      className: 'legend-lesson-filler',
    },{
      label: this.$t('courses.subjectBuilder.holiday'),
      value: FIXED.HOLIDAY,
      className: 'legend-holiday',
    },{
      label: this.$t('courses.subjectBuilder.dayOff'),
      value: FIXED.DAY_OFF,
      className: 'legend-day-off',
    },{
      label: this.$t(`courses.subjectBuilder.${funLabel}`),
      value: FIXED.FUN,
      className: 'legend-lesson-fun',
    }];

    return types;
  }

  get calendarComponent() {
    const subjectCalendarLesson: any = this.$refs?.subjectCalendarLesson;
    const subjectCalendarDates: any = this.$refs?.subjectCalendarDates;

    return this.isLessonStep ? subjectCalendarLesson : subjectCalendarDates;
  }

  get allLessons() : Map<number, BuilderLesson> {
    return this.builder?.allLessonsMap || new Map<number, BuilderLesson>();
  }

  get dataReady(){
    if(this.builder && this.builder.allLessonsMap && this.builder.allLessonsMap.size > 0 && this.allCalendars)
      return true
    return false
  }

  get schoolDayReady() {
    let show = false;
    if(this.isQuickSubject || this.contentDetail.status === BUILDER_STATUS.DONE) {
      if(this.contentDetail?.schoolDay) {
        show = true;
      } else {
        show = false
      }
    } 
    return show;
  }

  get statusSyncOut() {
    return this.builder.syncStatus === BUILDER_SYNC_STATUS.OUT;
  }
  
  get statusSyncPending() {
    return this.builder.syncStatus === BUILDER_SYNC_STATUS.PENDING;
  }

  get statusSyncDone() {
    return this.builder.syncStatus === BUILDER_SYNC_STATUS.DONE;
  }

  get statusSyncProcess() {
    return this.builder.syncStatus === BUILDER_SYNC_STATUS.PROCESS;
  }

  get enabledWorkingDays() {
    const sd = this.allCalendars.find(sd => sd.schoolDay.schoolDayId === this.selectedSubjectDays);
    if (!sd)
      return  Object.values(WORKING_DAYS).filter(value => typeof value === 'string');
    
    if(this.isQuickSubject)
      return sd.workingDays.filter(wd => this.builder.schedule.has(wd));
    
    return sd.workingDays    
  }

  get courseStore(): Course {
    if(this.builderId) {
      let indexCourse: number = this.$store.state.CourseStore.courses.content.findIndex( (course: Course) => {
        if(this.classId) return course.id == this.builderId && course.classId == this.classId;
        else return course.id == this.builderId;
      });
      return this.$store.state.CourseStore.courses.content[indexCourse];
    }
    return null;
  }

  get hasLessons() {  
    return this.builder &&  this.builder.allLessonsMap?.size > 0;
  }

  get locale(){
    return this.$i18n.locale;
  }

  /* Methods */
  public goBack() {
    if(this.isQuickSubject) {
      this.$router.push({ name: 'class-admin' });
    } else {
      this.$router.push({ name: ALL_CONTENT_ROUTES.TEMPLATES.NAME });
    }
  }

  public async goStep2(){
    this.saveSubjectDescriptionClick();
    this.step = 2;
    this.changeActiveTab(this.step);
  }

  async saveBuilder() {
    if(!this.disableSync)
      this.$edEventBus.$emit(COURSES_EVENTS.SUBJECT_DESCRIPTION_BUILDER, true);
  }

  async getTemplateDescription() {
    try {
      if(this.builderId > 0) {  //when we have the builder id, load from indexDB
        this.setCourseOnStore();
        
        let builderData = await this.$BuilderCache.getFile(`builder_${this.builderId}`, FILESCACHE_KEYS.BUILDER_DATA);
        if(builderData && builderData.file) {
          this.contentDetail = builderData.file.subject;
          this.contentDetail.status = this.contentDetail.status ?? builderData.file.status;
          this.builder = {...builderData.file}
          this.initialType = this.builder.initialType;
          if(this.isQuickSubject) this.templateIdFromQuickSubject = builderData.file.templateId;
        }
      } 
      
      if(this.builderId == 0) { //When we don't have the builder id, load the data from the server (template and quick subject info)
        await this.getTemplateStructureData();
      }
      
      if(this.isQuickSubject) {
        this.contentDetail.schoolDayComplate = this.allCalendars[0].schoolDay;
        this.contentDetail.schoolDay = this.allCalendars[0].schoolDay.schoolDayId;
      }
    } catch (err){
      this.$EdToast.create({ 
        msg:  `${this.$t('courseTemplates.errors.errorLoadingCourseTemplate')}`,
        type: TOAST_TYPES.DANGER,
        top: '3rem',
        timeout: 3000
      });
    }
  }

  /**
   * Saves the builder data locally
   * Also saves the structure of the builder if it doesn't exist on the store. Do not override this structure on future 
   * iterations to keep the original structure of the template when re building the subject structure.
   */
  async saveBuilderLocally(){
    await this.$BuilderCache.cacheFile(`builder_${this.builderId}`, this.builder, FILESCACHE_KEYS.BUILDER_DATA);   
    let structure = await this.$BuilderCache.getFile(`snaptshot_${this.builderId}`, FILESCACHE_KEYS.BUILDER_DATA);
    if(!structure || !structure.file) {    
      const data = await this.$Builder.Services.getTemplatesStructureById(this.templateId);
      const newStructure = new Structure(
        data.contentStructure, data.fillerStructure, data.funStructure, data.additionalStructure, data.lessons, 
        data.templates[0].materials, data.templates[0].projects, data.templates[0].deckLibrary,
        this.builder.allContentLessons, this.builder.allFillerLessons, this.builder.allFunLessons,
        this.builder.additionalLessons, this.builder.allLessonsMap);
      await this.$BuilderCache.cacheFile(`snaptshot_${this.builderId}`, newStructure.toSnapshot(), FILESCACHE_KEYS.BUILDER_DATA);
    }
  }

  async validateLessonsDate() {
    const today = new Date();
    const dateString = this.builder?.allLessonsMap.entries().next().value?.[1]?.startSchoolDate;
    const startLessonDate = dateString ? new Date(`${dateString}T00:00:00`) : null;
    if(startLessonDate?.getTime() <= today.getTime()) {
      if(this.builder.status === BUILDER_STATUS.DRAFT) {
        await this.setCalendarSlots();
        await this.$Builder.Services.removeSlotDataToLessons(this.builder.allLessonsMap);
        await this.setAllLessonsBySchoolDays();
      } else {
          //TODO on status READY should move only lesson on the future
      }
      await this.saveBuilderLocally()
    } else {
      this.builder.automaticStructure = await this.$Builder.Services.buildSubjectStructure(this.builder);
      await this.updateCourseDataOnStore();
    }
  }

  private async getTemplateStructureData() {
    let content = null;
    let componentsSelected = null;
    if(this.isQuickSubject) {
      const res = await ClassesService.getQuickContent(this.templateId, this.quickContentId);
      this.templateIdFromQuickSubject = res.templateId;
      content = res.subject;
      componentsSelected = res.componentsSelected;
      this.idBuilder = this.quickContentId;
    } else {
      this.idBuilder = Number(`${this.templateId}${Date.now()}`);
    }

    this.setCourseOnStore();
    
    const data = await this.$Builder.Services.updateTemplatesStructureFromServer(this.templateId);
    const template = data.templates[0];
    if(!content) {
      content = template.content;
    }

    this.contentDetail = {
      id: content.contentId,
      title: content.contentTitle,
      img: content.coverThumbnailSmallUrl,
      defaultDueDateForTasks: content.defaultDueDateForTasks,
      defaultLastDateForTasks: content.defaultLastDateForTasks,
      contentSummary: content.contentSummary,
      categoryId: content.category.id,
      imgHash: content.coverImg,
      hasGrading: content.hasGrading,
      actualGrade: content.actualGrade,
      suggestedGrade: content.suggestedGrade,
      suggestedLessonDuration: content.suggestedLessonDuration,
      schoolDay: content.schoolDay,
      duration: content.duration,
      components: template.components,
      componentsSelected: componentsSelected,
      type: content.type,
      classId: this.classId ? this.classId : null,
      version: content.version
    };

    this.builder = {
      ...this.builder,
      subject: { ...this.contentDetail },
      status: BUILDER_STATUS.DRAFT,
      builderId: this.idBuilder,
      templateId: this.templateId,
      contentId: (this.isQuickSubject) ? this.quickContentId : null
    };
  }

  private setCourseOnStore() {
    let course = new Course({ id: this.idBuilder });
    course.classId = this.classId ? this.classId : null;
    this.$Courses.Store.setCourseInfo(course);
  }

  saveSubjectDescriptionClick() {
    this.$edEventBus.$emit(COURSES_EVENTS.SUBJECT_DESCRIPTION_BUILDER);
  }

  async syncSubjectDescription({formData, uploadedImage}) {
    await this.saveSubjectDescription({formData, uploadedImage});
    await this.saveBuilderDataOnQueue();
  }
  
  private syncWorkerDebounced = _.debounce(() => {
    this.$edEventBus.$emit(WORKER_EVENT_BUS.SEND_SYNC_WORKER_MESSAGE);
  }, 1000);

  async saveBuilderDataOnQueue() {
    this.disableSyncButtons = true;
    const builderVersion = await this.$Builder.Queue.saveBuilderDataOnQueue(this.builderId, this.builder);
    this.builder.syncStatus = BUILDER_SYNC_STATUS.PENDING;
    this.builder.version = builderVersion;
    await this.saveBuilderLocally();
    this.syncWorkerDebounced();
    //TODO: Enable save buttons when there are changes after saving
    this.disableSyncButtons = false;
  }

  async uploadBuilderDataOnQueue() {
    this.disableSyncButtons = true;
    const builderVersion = await this.$Builder.Queue.saveUploadBuilderDataOnQueue(this.builderId, this.builder);
    this.builder.status = BUILDER_STATUS.PENDING;
    this.builder.syncStatus = BUILDER_SYNC_STATUS.PENDING;
    this.builder.version = builderVersion;
    await this.saveBuilderLocally();
    this.syncWorkerDebounced();
    this.$router.push({ name: ALL_CONTENT_ROUTES.SUBJECTS.NAME });
  }

  async saveSubjectDescription({formData, uploadedImage}) {
    try {
      this.status.setLoading();

      this.contentDetail = {
        ...formData,
        title: formData.contentTitle,
        img: formData.coverImageUrl,
        defaultDueDateForTasks: formData.defaultDueDateForTasks,
        defaultLastDateForTasks: formData.defaultLastDateForTasks,
        contentSummary: formData.contentSummary,
        imgHash: formData.coverImg,
        actualGrade: formData.actualGradeId,
        suggestedGrade: formData.suggestedGradeId,
        coverId: uploadedImage?.file ? null : this.builder?.subject?.coverId,
        fitFirstAvailable: formData.fitFirstAvailable,
        lessonVariance: formData.lessonVariance,
        components: this.contentDetail.components,
        id: (this.isQuickSubject) ? this.builderId : this.templateId,
        type: this.type,
        classId: this.classId ? this.classId : null,
        version: formData.version,
        status: this.builder?.subject?.status,
      };

      if(this.isQuickSubject) {//If the content is a quick then we use the first schoolday
        this.contentDetail.schoolDayComplate = this.allCalendars[0].schoolDay;
        this.contentDetail.schoolDay = this.allCalendars[0].schoolDay.schoolDayId;
      } else if(this.builder.status === BUILDER_STATUS.DONE) {//If the status is READY then we use the builder data downloaded
        this.contentDetail.schoolDayComplate = this.builder.subject.schoolDayComplate ?? this.builder.schoolDay;
        this.contentDetail.schoolDay = this.builder.subject.schoolDayComplate?.schoolDayId ?? this.builder.schoolDay.schoolDayId;
      }

      const { holidayPlan, workingDays, schoolDay } = await this.getCalendarData();
      //If user change the calendar on first builder step then we use the calendar data from indexDB
      const shouldUseExistingData = formData?.schoolCalendarChanged ?? false; 
      
      this.builder = {
        ...this.builder,
        //If the builder has calendar data and the calendar not change, then we use builder data else we use calendar data from indexDB
        workingDays: (this.builder?.workingDays && !shouldUseExistingData) ? this.builder.workingDays : [...workingDays],
        schoolDay: (this.builder?.schoolDay  && !shouldUseExistingData) ? this.builder.schoolDay : {...schoolDay},
        specialDays: (this.builder?.specialDays && !shouldUseExistingData) ? this.builder.specialDays : [...holidayPlan],
        subject: {...this.contentDetail},
        coverImage: uploadedImage?.file,
        existFunLessons: formData.existChanges ? null : this.builder?.existFunLessons,
        automaticFolderType: formData.automaticFolderType,
        componentsSelected: formData.componentsSelected,
        status: (this.builder?.status) ?? BUILDER_STATUS.DRAFT,
        builderId: this.idBuilder,
        syncStatus: this.builder?.syncStatus ?? BUILDER_SYNC_STATUS.OUT,
        templateId: this.templateId
      };
      
      if(formData.existChanges || BUILDER_SYNC_STATUS.READY_DOWNLOAD === this.syncStatus) {
        await this.resetAllData(formData);
      }
      
      //If the builder not has lessons asociated to components selected, then we go to show message about that
      if(this.builder.allLessonsMap?.size === 0) {
        this.noLessons()
        this.status.setLoad();
        this.disableSync = true;
        return;
      }

      await this.saveBuilderLocally();
      this.disableSync = false;
      this.status.setLoad();
    } catch(err) {
      this.status.setError();
    }
  }

  private noLessons(){
    this.$EdModal.createMessageModal({
      title: this.$i18n.t('courses.subjectBuilder.errors.emptyTemplate'),
      body: this.$i18n.t('courses.subjectBuilder.errors.emptyTemplateBody'),
      type: KEYS.EVENT_TYPES.WARNING,
      action: () => {
        this.step = 1;
        this.changeActiveTab(this.step);
      }
    });
  }

  private async resetAllData(formData?) {
    const today = new Date();
    if(formData?.lessonVarianceChanged && this.builder.status === BUILDER_STATUS.DONE) {
       //TODO pending analize how can we return or move data from additional lesson to content lessons after upload content
    }
    if(formData?.componentsChanged && this.builder.status === BUILDER_STATUS.DONE) {
      //TODO pending analize how can we return or move data from additional lesson to content lessons after upload content
    }
    //If the user only change automatic folder on first step, then we only need to change the automatic structure and update subject on vue store
    if(formData?.automaticFolderChanged && 
      !formData?.fitFirstAvailableChanged && 
      !formData?.lessonVarianceChanged && 
      !formData?.componentsChanged && 
      !formData?.schoolCalendarChanged) {
        await this.buildAutomaticStructure();
        return;
    }

    let startDate = new Date(this.schoolDay.dates[0]).toISOString().split('T')[0] ;
    //If builder is READY then we don't use calendar or lessons from store, because it has data on builder
    if(this.builder.status === BUILDER_STATUS.DONE) {
      if (new Date(startDate) < today) {
        startDate =  this.$Builder.Services.getTomorrowDate();    //When status is DONE, do not reset past lessons
      }
    } else if((BUILDER_SYNC_STATUS.READY_DOWNLOAD !== this.syncStatus) //If builder is different to download -> It's a draft
        || (formData?.schoolCalendarChanged || formData?.componentsChanged)) {//
      await this.setCalendarSlots();
      await this.getContentLessons();
    } 

    log.info(`Builder status: ${this.builder.status}.  Sync status: ${this.syncStatus} - Reset builder data from ${startDate}`);
    //If the builder has downloaded and it not has changes on first builder step
    if(!(BUILDER_SYNC_STATUS.READY_DOWNLOAD === this.syncStatus && !formData?.existChanges)) {
      this.$Builder.Services.resetSlotDataFromSlotDay(startDate, this.builder.schoolDaysSlotsMap);
      this.$Builder.Services.resetLessonDataFromSlotDay(startDate, this.builder.allLessonsMap);
      
    } 
    
    await this.setAllLessonsByComponents();
    await this.setAllLessonsBySchoolDays();
  }

  private async buildAutomaticStructure() {
    this.builder.automaticStructure = await this.$Builder.Services.buildSubjectStructure(this.builder);
    await this.updateCourseDataOnStore();
  }

  changeMenuTab(tabId) {
    if(!this.disabledSubjectForm && this.builder.schoolDay?.entityId && this.hasLessons) {
      this.step = tabId;
      if(this.step > 1) {
        this.saveSubjectDescriptionClick();
      }
      this.changeActiveTab(tabId);
    }
  }

  changeActiveTab(tabId) {
    this.menu = this.menu.map(m => ({...m, active: m.id === tabId}));
    this.calendarType = this.calendarTypes.CALENDAR;
    const container = document.querySelector('body');
    if(this.step !== 2 && this.$refs.sidebar){ //Close sidebar on other steps
      (this.$refs.sidebar as any)?.closeContentSidebar();
    }
    setTimeout(() => {
      container?.scrollTo({ top: 0 });
    }, 200);
  }

  openConfigWorkingDays() {
    this.$edEventBus.$emit('openConfigWorkingDays')
  }

  async getCalendarData() {
    const sd = this.allCalendars.find(sd => sd.schoolDay.schoolDayId === this.selectedSubjectDays);
    if (!sd) {
      return { holidayPlan: null, workingDays: [], schoolDay: null };
    }
    let realWorkingDays = this.builder.workingDays ?? sd.workingDays;

    if(this.isQuickSubject && this.builder.scheduleType == ScheduleTypeEnum.WEEK){
      realWorkingDays = realWorkingDays
        .filter(wd => this.builder.schedule.has(wd));
    }
  
    return {
      holidayPlan: sd.holidayPlan ?? this.builder.specialDays,
      workingDays: realWorkingDays,
      schoolDay: sd.schoolDay ?? this.builder.schoolDay,
    };
  }

  async runRule(rule, rulesApplied = null) {
    try {  
      this.status.setLoading();

      //console.log('rule : ', rule);
      this.closeSidebar();

      let specialDays = this.specialDays;
      if(rule?.type == BUILDER_RULES.START_LESSON) {
        specialDays = this.specialDays.filter(
          el => !el.addedByRule
        );
      }

      this.builder.specialDays = specialDays;
      
      await this.$Builder.Services.applyRules(rule, this.builder, this.isQuickSubject);
      
      await this.setAllLessonsBySchoolDays();

      const rules = await this.$Builder.Services.reorderRulesApplied(rule, rulesApplied ?? this.rulesApplied)
      this.builder.rulesApplied = [...rules];
      await this.saveBuilderLocally();

      this.status.setLoad();
    } catch(err) {
      this.status.setError();
    }
  }

  setUpdateRule({rule}) {
    this.toggleAddRules();
    this.ruleOptions = rule;
  }

  updateRule(rule) {
    const rulesApplied = this.rulesApplied.filter(el => el !== this.ruleOptions);
    this.runRule(rule, rulesApplied);
    this.ruleOptions = null;
  }

  removeRule({rule}) {
    let repeatedRules = [];
    if(rule.type === BUILDER_RULES.START_LESSON)
      repeatedRules = this.rulesApplied.filter(el => el.type === BUILDER_RULES.START_LESSON && el !== rule);
    else 
      repeatedRules = this.rulesApplied.filter(el => el.label === rule.label && el !== rule);

    let runRule
    if(repeatedRules.length > 0 && rule.active) {
      runRule = repeatedRules[repeatedRules.length-1];
    } else if(repeatedRules.length > 0 && !rule.active) {
      runRule = null;
    } else {
      if(rule.type === BUILDER_RULES.START_LESSON)
        runRule = { type: BUILDER_RULES.REMOVE_START_LESSON }
      else
        runRule = { type: BUILDER_RULES.REMOVE_PLACE_LABEL, label: rule.label };
    }

    const rulesApplied = this.rulesApplied.filter(el => el !== rule && el !== runRule);
    this.runRule(runRule, rulesApplied);
  }

  reRunRule({rule}) {
    const rulesApplied = this.rulesApplied.filter(el => el !== rule);
    this.runRule(rule, rulesApplied);
  } 

  toggleAddRules() {
    this.addRule = !this.addRule;
    this.ruleOptions = null;
  }

  openSidebar() {
    this.addRule = false;
    this.isSidebarOpened = true;
  }

  closeSidebar() {
    this.isSidebarOpened = false;
  }

  openContentSidebar() {
    this.isSidebarContentOpened = true;
  }

  closeContentSidebar() {
    this.isSidebarContentOpened = false;
  }

  onUpdateLessonDates(lessonDate) {
    if (this.builder.allLessonsMap && this.builder.allLessonsMap.has(lessonDate.id)) {
      const value = this.builder.allLessonsMap.get(lessonDate.id);
      if (value) {
        value.startSchoolDate = lessonDate.schoolDate; 
        value.endSchoolDate = lessonDate.endSchoolDate; 
      }
    }
  }

  async updateCourseDataOnStore() {
    const dataStructure = await this.$Builder.Services.getStructure(this.builderId, this.templateId, false);
    const content = await this.$Builder.Services.getBuilderDataToSaveOnStore(this.builder.subject, this.builder.automaticStructure, dataStructure);
    if(content) {
      await this.$Courses.Store.setContentForCourse({data: content, courseId: this.builderId, classId: this.classId });
    }
  }

  async onSaveTeachingDays(data) {
    if(!_.isEqual(this.builder.workingDays, data.workingDays)) {
      this.builder.workingDays = data.workingDays
      await this.resetAllData();
      await this.saveBuilderLocally();
    }
  }

  async onRefreshSubjectBuilder() {
    try {
      this.status.setLoading();

      this.status.setLoad();
    } catch(err) {
      this.status.setError();
    }
  }

  async onSetSpecialDays({ specialDays, rule, option, prevOption, date }) {
    //console.log('rule : ', specialDays, rule, option, prevOption, date);
    try {  
      this.status.setLoading();
      if(rule) {
        await this.$Builder.Services.applyRules(rule, this.builder, this.isQuickSubject);
      } else if(option === BUILDER_DAY_OPTIONS.FUN) {
        await this.$Builder.Services.addFunLessonToFunDay(date, this.builder);
      } else if(option === BUILDER_DAY_OPTIONS.IGNORED) {
        await this.$Builder.Services.addStandardDate(date, this.builder);
      }
      
      this.builder.specialDays = specialDays;
      await this.setAllLessonsBySchoolDays();
      await this.saveBuilderLocally();
      
      this.status.setLoad();  
    } catch(err) {
      this.status.setError();
      this.calendarComponent.goToPresentDay();
    }
  }

  async setAllLessons() {
    let builderData = await this.$BuilderCache.getFile(`builder_${this.builderId}`, FILESCACHE_KEYS.BUILDER_DATA);
    if(builderData && builderData.file && builderData.file.allLessonsMap?.size > 0) {
      this.builder = builderData.file;
      this.validateLessonsDate();
    } else {
      await this.getContentLessons();
    }
  }

  public subjectDaysChanged(selectedSubjectDays : number){
   this.selectedSubjectDays = selectedSubjectDays;
  }

  private async setCalendarSlots(){
    await this.$Builder.Services.setCalendarSlots(this.builder, 
      this.builder.specialDays,
      this.builder.workingDays, 
      this.builder.schoolDay, 
      this.quickContentId);
  }

  async setAllLessonsByComponents() {
    const lessonsFilteredMap = await this.$Builder.Services.filterLessonsByComponentSelectedMap(this.builder.allLessonsMap, this.additionalLessons, this.componentsSelected);
    this.builder.allLessonsMap = lessonsFilteredMap;
  }

  async setAllLessonsBySchoolDays() {
    await this.$Builder.Services.shuffleLessonsBySlotsByMap(this.builder);
    await this.$Builder.Services.moveLessonToAdditionalContent(this.builder);
    //Builder automatic structure and save that on vue store to show on edit content structure
    this.buildAutomaticStructure();
  }

  async setSchoolCalendarData() {
    if(this.builder.status === BUILDER_STATUS.DONE) {//If the subject was uploaded (READY)
      this.allCalendars = [{schoolDay: this.builder.schoolDay, workingDays: this.builder.workingDays, specialDays: this.builder.specialDays}];
      this.builder.schedule = new Map<string, ContentSchedule[]>();
      this.typeSchoolDay = BUILDER_SCHOOL_DAY_TYPES.SUBJECT;
      this.contentDetail.schoolDayComplate = this.contentDetail.schoolDayComplate ?? this.builder.schoolDay;
      this.contentDetail.schoolDay = this.contentDetail.schoolDay ?? this.builder.schoolDay.schoolDayId;
    } else if(this.isQuickSubject) {
      this.allCalendars = await this.$Builder.Services.updateClassCalendarListFromServer(this.classId);
      if(!this.builder?.schedule || this.builder?.schedule?.size == 0) {//If the quick subject builder not has schedule we need to download
        this.builder.schedule = await this.$Builder.Services.getSubjectSchedule(this.classId, this.quickContentId);
      }
      if(!this.builder?.scheduleType) {
        let data = await this.$Builder.Services.getScheduleType(this.classId);
        this.builder.scheduleType = data ? data.scheduleType : ScheduleTypeEnum.WEEK;
        this.builder.scheduleShortDay = data ? data.scheduleShortDay : null;
      }
      this.contentDetail.schoolDayComplate = this.allCalendars[0].schoolDay;
      this.contentDetail.schoolDay = this.allCalendars[0].schoolDay.schoolDayId;
      this.typeSchoolDay =  BUILDER_SCHOOL_DAY_TYPES.CLASS;
    } else {
      this.allCalendars = await this.$Builder.Services.updateSchoolCalendarListFromServer(this.organizationId);
      this.builder.schedule = new Map<string, ContentSchedule[]>();
      this.builder.scheduleType = ScheduleTypeEnum.WEEK;
      this.typeSchoolDay =  BUILDER_SCHOOL_DAY_TYPES.ORG;
    }
  }

  async getContentLessons() {
    this.builder.allLessonsMap = new Map<number, BuilderLesson>();
    this.builder.allContentLessons = [];
    this.builder.allFillerLessons = [];
    this.builder.allFunLessons = [];
    this.builder.additionalLessons = [];

    let data = await this.$Builder.Services.getStructure(this.builderId, this.templateId);
    
    if(data && data.allLessonsMap?.size > 0) {
      this.builder.allLessonsMap = data.allLessonsMap;
      this.builder.allContentLessons = data.allContentLessons;
      this.builder.allFillerLessons = data.allFillerLessons;
      this.builder.allFunLessons = data.allFunLessons;
      this.builder.additionalLessons = data.additionalLessons;
    } else {
      let fixedSequenceAllLessons: number = 0;
      data = await this.$Builder.Services.getTemplatesStructureById(this.templateId);
      fixedSequenceAllLessons = await this.$Builder.Services.getBuilderAllLessonsFromCache(data, FIXED.CONTENT, this.builder.allContentLessons, this.builder.allLessonsMap, fixedSequenceAllLessons);
      fixedSequenceAllLessons = await this.$Builder.Services.getBuilderAllLessonsFromCache(data, FIXED.FILLER,  this.builder.allFillerLessons, this.builder.allLessonsMap, fixedSequenceAllLessons);
      await this.$Builder.Services.getBuilderAllLessonsFromCache(data, FIXED.FUN, this.builder.allFunLessons, null);
    }
    
  }

  closeModal() {
    this.$EdModal.closeModal();
  }

  // startWorker() {
  //   if(!this.worker) {
  //     this.worker = new ServerStatusWorker();
  //     this.worker.postMessage({ 
  //       serviceUrl: APP_API.HEALTH_API, 
  //       interval: 2000
  //     });

  //     this.worker.onmessage = (event: MessageEvent<{ connected: boolean }>) => {
  //       console.log('worker says:', event.data.connected)
  //       this.connected = event.data.connected;
  //     };
  //   }

  // }

  // finishWorker() {
  //   if (this.worker) {
  //     this.worker.terminate();
  //     this.worker = null;
  //   }
  // }

  updateBuilderStatus({builderId, status}) {
    if(this.builderId === builderId){
      this.builder.syncStatus = status;
    }
  }
  
  handleOffline(offline: boolean) {
    this.connected = !offline;
  }

  async initFlow() {
    //If builder is downloaded then we need to get data from server
    if(BUILDER_SYNC_STATUS.READY_DOWNLOAD === this.syncStatus) {
      this.builder = await this.$Builder.Services.getSubjectDataBuilderFromServer(this.builderId, this.classId);
      this.initialType = this.builder.initialType; //Set the initial type before checking this.isQuickSubject
      this.contentDetail = this.builder.subject;
      await this.setSchoolCalendarData();
      this.setCourseOnStore();
      if(this.isQuickSubject)
        this.templateIdFromQuickSubject = this.builder.templateId;
    } else {
      await this.getTemplateDescription();
      await this.setSchoolCalendarData();
      await this.setAllLessons();
    }
  }

    public printStatus(){
      if(!this.builder || !this.builder.schoolDaysSlots) {
        log.info('Builder not initialized');
        return;
      }
        
      // Helper to pad strings to a fixed width
      function pad(str: any, width: number) {
        str = str === undefined || str === null ? '' : String(str);
        return str.length >= width ? str.slice(0, width) : str + ' '.repeat(width - str.length);
      }

      // Define column widths for schoolDaysSlots
      const schoolDaysSlotsCols = [
        { header: 'SchoolDay', width: 10 },
        { header: 'Date', width: 12 },
        { header: 'DayOfWeek', width: 10 },
        { header: 'A/B', width: 5 },
        { header: 'TotalTime', width: 10 },
        { header: 'TimeAvail', width: 10 },
        { header: 'UnusedTime', width: 10 },
        { header: 'Status', width: 8 },
        { header: 'Lessons', width: 18 },
        { header: 'AllowedTypes', width: 22 }
      ];

      // Print schoolDaysSlots table
      const schoolDaysSlotsHeader = schoolDaysSlotsCols.map(col => pad(col.header, col.width)).join(' | ');
      const schoolDaysSlotsTable = this.builder.schoolDaysSlots.map(slot =>
        [
          pad(slot.schoolDay, 10),
          pad(slot.date.toISOString().split('T')[0], 12),
          pad(slot.dayOfWeek, 10),
          pad(slot.dayAB, 5),
          pad(slot.totalTime, 10),
          pad(slot.timeAvailable, 10),
          pad(slot.unusedTime, 10),
          pad(slot.status, 8),
          pad(JSON.stringify(slot.lessons), 18),
          pad(JSON.stringify(slot.allowedTypes), 22)
        ].join(' | ')
      );
      log.debug(schoolDaysSlotsHeader + '\n' + schoolDaysSlotsTable.join('\n'));

      // Define column widths for allContentLessons
      const allContentLessonsCols = [
        { header: 'LessonID', width: 8 },
        { header: 'Name', width: 18 },
        { header: 'FixedSeq', width: 9 },
        { header: 'FixedOrd', width: 9 },
        { header: 'RootType', width: 9 },
        { header: 'Duration', width: 8 },
        { header: 'PendTime', width: 8 },
        { header: 'Status', width: 8 },
        { header: 'Days', width: 13 },
        { header: 'Dates', width: 23 }
      ];

      // Print allContentLessons table
      const allContentLessonsHeader = allContentLessonsCols.map(col => pad(col.header, col.width)).join(' | ');
      const allContentLessonsTable = Array.from(this.builder.allLessonsMap.values()).map(lesson =>
        [
          pad(lesson.id, 8),
          pad(lesson.name, 18),
          pad(lesson.fixedSequence, 9),
          pad(lesson.fixedOrder, 9),
          pad(lesson.rootType, 9),
          pad(lesson.duration, 8),
          pad(lesson.pendingTime, 8),
          pad(lesson.status, 8),
          pad(`${lesson.startDay} - ${lesson.endDay}`, 13),
          pad(`${lesson.startSchoolDate} - ${lesson.endSchoolDate}`, 23)
        ].join(' | ')
      );
      log.debug(allContentLessonsHeader + '\n' + allContentLessonsTable.join('\n'));

    }

    public async clearStore(){
      await this.$Builder.Services.deleteAllDataFromIndexDB(this.builder.builderId);
      log.warn('Store was cleaned for builder:', this.builder.builderId);
      this.step = 1;
      this.changeActiveTab(this.step);
      this.$router.go(0);
    }

    public async reshuffle(){
      await this.resetAllData();
    }


  @Watch('locale') 
  buildMenu(){
    this.menu = BUILDER_MENU_V2.map((m: any) => {
      return new EdTabsHeaderOption({
        ...m,
        active: m.id === this.step,
        label: this.$i18n.t(`courses.subjectBuilder.${m.label}`),
      });
    });
  }

  verifyKeyDown(event: KeyboardEvent) {
    if (event.metaKey && event.shiftKey && event.code === 'KeyB') {
      this.isDeveloperMode = true;
    }
  }
  

  // Ensure context menu component is available in all builder steps
  private _setMenuContextContainer(): void {
    const _getElementsByClass = (key: string): HTMLElement[] =>
        Array.from(document.getElementsByClassName(key)).map(element => element as HTMLElement);
    const steps = _getElementsByClass('ed-stepper');
    const menus = _getElementsByClass('ed-context-menu-container');

    steps?.forEach(step => {
      menus?.forEach(menu => {
        step?.appendChild(menu);
      });
    });
  }

  mounted() {
    document.querySelector('body').style.overflow = 'auto';
    this.connected = navigator.onLine;  //Initial conection state 

    this.initFlow();
    // this.startWorker();
    this.$edEventBus.$on(WORKER_EVENT_BUS.SYNC_BUILDER_STATUS, this.updateBuilderStatus);
    this.$App.Store.setSubjectBuilderActive(true);
    this.$edEventBus.$on(OFFLINE_MODE_EVENT, this.handleOffline);

    if(process.env.NODE_ENV === 'development')
      this.isDeveloperMode = true;
    else
      window.addEventListener('keydown', this.verifyKeyDown);   //Add listener  to print status
     //Add listener  to print status

    setTimeout(() => {
      this._setMenuContextContainer();
    }, 1000);
  }

  created() {
    this.$edEventBus.$on(COURSE_TEMPLATE_EVENTS.SAVE_COURSE_FORM, this.saveSubjectDescription);
    this.$edEventBus.$on(COURSE_TEMPLATE_EVENTS.SAVE_SYNC_BUILDER_FORM, this.syncSubjectDescription);
    this.buildMenu()
    this.status.setLoading();
  }

  beforeDestroy() {
    // this.finishWorker();
    this.$edEventBus.$off(COURSE_TEMPLATE_EVENTS.SAVE_COURSE_FORM);
    this.$edEventBus.$off(COURSE_TEMPLATE_EVENTS.SAVE_SYNC_BUILDER_FORM);
    this.$edEventBus.$off(OFFLINE_MODE_EVENT, this.handleOffline);
    this.$edEventBus.$off(WORKER_EVENT_BUS.SYNC_BUILDER_STATUS);
    this.$App.Store.setSubjectBuilderActive(false);
    window.removeEventListener('keydown', this.verifyKeyDown);  //Remove listener to print status
  }

}